import { Box, Typography, useTheme } from "@mui/material";

type HeaderType<T> = T extends undefined ? string : keyof T;
export function StepperPageHeader<T extends { [stepName: string]: string }>({
  header,
  description,
  headerButton,
  mb = 3,
  smallDescription = false,
}: {
  header: HeaderType<T>;
  description?: React.ReactNode;
  headerButton?: React.ReactNode;
  mb?: number;
  smallDescription?: boolean;
}) {
  const theme = useTheme();
  const descriptionSx = smallDescription
    ? {
        fontSize: theme.typography.caption.fontSize,
        mb: 3,
        color: theme.palette.text.secondary,
      }
    : {
        fontSize: theme.typography.htmlFontSize - 2,
        mb: 3,
      };

  return (
    <Box mb={theme.spacing(mb)} sx={{ width: "80%" }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: description ? 3 : 0 }}
      >
        <Typography variant="h5">{header}</Typography>
        {headerButton}
      </Box>
      {description && (
        <Typography variant="caption" sx={descriptionSx}>
          {description}
        </Typography>
      )}
    </Box>
  );
}
